import { gql } from "@apollo/client";

export const CREATE_SECTION = gql`
  mutation adminCreateSection($input: CreateSectionInput!) {
    adminCreateSection(input: $input) {
      id
      order
      elements {
        kind
        meta
      }
    }
  }
`;

export const EDIT_SECTION = gql`
  mutation adminEditSection($id: String!, $input: EditSectionInput!) {
    adminEditSection(id: $id, input: $input) {
      id
      order
      elements {
        kind
        meta
      }
    }
  }
`;

export const DELETE_SECTION = gql`
  mutation adminDeleteSection($id: String!) {
    adminDeleteSection(id: $id) {
      reason
      status
    }
  }
`;
